"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pxVal = exports.getScrollTop = exports.removeClassName = exports.addClassName = exports.getStyle = exports.closest = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview dom相关
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */


var _index = require("../array/index");

var haveJQuery = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && typeof window.jQuery !== "undefined";

/**
 * 获取父元素
 * @param {Object} dom dom节点
 * @param {*} selector querySelector的参数
 * @returns {Object} dom结构
 * @example
 * const parentNode = closest(childNode, '.parent');
 */
var closest = exports.closest = function closest() {
    var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var selector = arguments[1];

    var el = dom,
        matchesSelector = null;

    if (el) {
        matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

        while (el) {
            if (matchesSelector.call(el, selector)) {
                break;
            }
            el = el.parentElement;
        }
    }

    return el;
};

/**
 * 获取dom style样式
 * @param {Object} dom dom节点
 * @param {String} attr 属性名称
 * @returns {any} 属性值
 * @example
 * const value = getStyle(node, 'width');
 */
var getStyle = exports.getStyle = function getStyle(dom) {
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    var result = "";

    if (attr && dom) {
        result = dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom, false)[attr];
    }

    return result;
};

/**
 * 添加className
 * @param {Object} dom dom节点
 * @param {String} className 要添加的className
 * @returns {Void}
 */
var addClassName = exports.addClassName = function addClassName() {
    var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    var domClassName = dom ? dom.className || "" : "";
    var domClassNameList = domClassName.split(" ");

    if (dom && className && (0, _index.indexOf)(domClassNameList, className) < 0) {
        domClassNameList.push(className);
        dom.className = domClassNameList.join(" ");
    }
};

/**
 * 去除className
 * @param {Object} dom dom节点
 * @param {String} className 要添加的className
 * @returns {Void}
 */
var removeClassName = exports.removeClassName = function removeClassName() {
    var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    var domClassName = dom ? dom.className || "" : "";
    var domClassNameList = domClassName.split(" "),
        result = [];

    if (dom && className && (0, _index.indexOf)(domClassNameList, className) > -1) {
        domClassNameList.map(function (item) {
            if (item !== className) {
                result.push(item);
            }
            return item;
        });
        dom.className = result.join(" ");
    }
};

/**
 * 获取对应的scrollTop
 * @param {string|Object} target dom节点或者'body'
 * @returns {Number} scrollTop数值
 */
var getScrollTop = exports.getScrollTop = function getScrollTop() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "body";

    var result = 0;

    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
        if (target === "body") {
            result = document.getElementsByTagName("html")[0].scrollTop || document.getElementsByTagName("body")[0].scrollTop || 0;
            if (result < 1 && haveJQuery) {
                result = jQuery("html").scrollTop() || jQuery("body").scrollTop();
            }
        } else if ((typeof target === "undefined" ? "undefined" : _typeof(target)) === "object") {
            result = target.scrollTop || 0;
            if (result < 1 && haveJQuery) {
                result = jQuery(target).scrollTop();
            }
        }
    }

    return result;
};

/**
 * 获取对应的 CSS 包装值， 如果是纯数字，则返回对应数字的像素值，反之返回原始值
 * @param {string|number} val 值
 * @returns {string|number} 值
 */
var pxVal = exports.pxVal = function pxVal(val) {
    return typeof val === "number" ? val + "px" : val;
};

exports.default = {
    closest: closest,
    getStyle: getStyle,
    addClassName: addClassName,
    removeClassName: removeClassName,
    getScrollTop: getScrollTop,
    pxVal: pxVal
};